import {
    React,
    useState,
    useEffect,
    useParams,
    Dialog,
    DialogTitle,
    Box,
    CloseIcon,
    Divider,
    DialogActions,
    DialogContent,
    Typography,
    DataGrid,
    GridColDef,
    Dayjs,
    dayjs,
    Grid2,
    IconButton,
    ModeEditOutlineIcon,
    AddCommentIcon,
    Tooltip,
    ViewCompactAltIcon
} from '../../../utils/globalImports';

import {
    SearchBar,
    CustomButton,
    CustomTextField,
    useApi,
    CustomDatePicker,
    Toaster,
    validationMessages,
    CustomBackdrop
} from '../../../utils/globalImports';


interface ModalProps {
    open: boolean;  // Prop to determine if the modal is open
    instructionReference?: string;
    isComments?: boolean;
    onClose: () => void;  // Function to handle modal close
    onSubmit: (formData: any) => void;
}

const AddEditCommentsReferenceModal: React.FC<ModalProps> = ({ open, instructionReference, isComments, onClose, onSubmit }) => {

    const [formData, setFormData] = useState({
        description: ''
    });

    const [errors, setErrors] = useState({
        description: ''
    });

    useEffect(() => {
        setFormData({
            description: isComments ? '' : instructionReference!,
        });

        setErrors({
            description: '',
        });

    }, [open]);

    const handleSubmit = () => {
        const errors = { description: '' };

        const field = isComments ? 'Comment' : 'Reference'
        if (!formData.description || !formData.description.trim()) {
            errors.description = validationMessages.common_required(field);
            setErrors(errors);
        }
        else if (field === 'Comment' && formData.description.length > 5000) {
            errors.description = validationMessages.common_characterLimit(field, 5000);
            setErrors(errors);
        }
        else {
            setErrors(errors);
            onSubmit(formData);
        }


    }

    return (
        <>
            {/* Modal Dialog */}
            <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
                <DialogTitle
                    sx={{
                        position: 'relative',
                        color: '#1e66ab',
                        alignItems: 'center',
                        display: 'flex',
                        justifyContent: 'center',
                        mb: 0,
                        fontWeight: 500,
                        fontSize: '24px'
                    }}>
                    {isComments ? 'Add Comment' : 'Edit Reference'}

                    <IconButton
                        color="inherit"
                        onClick={onClose}
                        sx={{
                            position: 'absolute',
                            right: 8, // Position the button at the right
                            top: 8,   // Position the button at the top
                        }}
                    >
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>

                <Divider></Divider>

                <DialogContent>

                    <Box sx={{ flexGrow: 1 }}>

                        <CustomTextField
                            label={!isComments ? "Reference" : "Description"}
                            name={!isComments ? "reference" : "description"}
                            value={formData.description}
                            onChange={(event) => setFormData({ ...formData, description: event.target.value })}
                            sx={{
                                mb: 1,
                                '& .MuiOutlinedInput-root': {
                                    borderColor: formData.description ? '#1e66ab' : 'default', // Highlight when value exists
                                    boxShadow: formData.description ? '0 0 5px rgba(30, 102, 171, 0.5)' : 'none', // Optional glow
                                },
                                '& .MuiOutlinedInput-notchedOutline': {
                                    borderColor: formData.description ? 'rgba(150, 193, 33, 0.75) !important' : 'default', // Ensures outline color
                                    borderWidth: formData.description ? '2px' : '1px', // Increased border width
                                },
                                '& .MuiInputBase-input': {
                                    backgroundColor: 'white', // Ensure input area has background
                                }
                            }}
                            isTextArea={!isComments ? false : true}
                        />
                        {errors.description && (
                            <Typography className="validationMessage" role="alert">
                                {errors.description}
                            </Typography>
                        )}




                    </Box>

                </DialogContent>
                <DialogActions sx={{ mb: 3 }}>
                    {/* Add User */}
                    <CustomButton
                        capsule
                        sx={{
                            mt: -1,
                            mb: 2,
                            width: '50%',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            textAlign: 'center',
                            margin: '0 auto', // Centers horizontally if parent has `display: block`
                            textTransform: 'none'
                        }}
                        onClick={handleSubmit}
                    >
                        {isComments ? 'Add Comment' : 'Edit Reference'}

                    </CustomButton>

                </DialogActions>
            </Dialog>
        </>
    );
}

export default AddEditCommentsReferenceModal;